export default __webpack_public_path__ + "static/media/demo-home.a6d678c4.png";